import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { LocalStorage } from '../../../utilities/storage';
import { Errors } from '../../errors';
import { getUserInfo } from '../../user/getUserInfo/getUserInfo.slice';

type InitialState = {
  loading: boolean;
  data?: boolean;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const checkToken = createAsyncThunk(
  'checkToken',
  async (_, { dispatch }) => {
    const token = LocalStorage.get(LocalStorage.token);
    if (token) {
      dispatch(getUserInfo());
    }
  }
);

const checkTokenSlice = createSlice({
  name: 'checkToken',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checkToken.pending, (state) => {
      state.loading = true;
      state.data = false;
      state.error = undefined;
    });
    builder.addCase(checkToken.fulfilled, (state) => {
      state.loading = false;
      state.data = true;
    });
    builder.addCase(checkToken.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default checkTokenSlice.reducer;
